import React from 'react';

import tobeor from 'tobeor';

import PidTitle from './TrplFormRowComponents/PidTitle';
import TrplFormValRenderer from "./TrplFormValRenderer";
import ParseHTML from '../ParseHTML';

export default
  ({
    row,
    data,
    formId,
    setTrpl,
    classes,
    isGroup,
    groupId,
    concept,
    account,
    rowIndex,
    isNewNode,
    ancestorId,
    loadingTids,
    deletedTids,
    getTrplNode,
    saveOnlyForm,
    isAnotherNode,
    accordeonData,
    submitOnlyForm,
    onRstValueEdit,
    getRstTrplsData,
    removeTrplValue,
    setLoadingTids,
    getRstMetaData,
    onRstTypeBtnClick,
    onNodeRemoveClick,
    setDeletedTrplId,
    openObjectEditModal,
    toggleUploadImgModal,
    isDisableTrplEditing,
    getAutocompleteTrpls,
    resetDeletedTrplId,
    showEmptyValOnBounds,
    onChangeTextereaHeight,
    updateDataOnRestoreTrpl,
    openTrplRenderPartsModal,
    onWidgetCheckboxesValueEdit,
    onNodeAddDropdownElementClick,
  }) => {

  return (
    <React.Fragment>
      {row && row.map((column, rowItemIndex) => {
        return (
          <div
            className={`${rowItemIndex > 0 ? classes.ml20 : ''}`}
            key={rowItemIndex}
            style={{
              width: column.children && column.children.find(item => (item.compType === 'value'
              && item.type && tobeor(item.type,
                ['INTEGER', 'FLOAT', 'STRING', 'TEXTAREA', 'URL', 'PRICE', 'PHONE', 'EMAIL',
                'FACEBOOK_MID', 'TELEGRAM_ID', 'FILE', 'IMAGE',
                'DATE', 'TIME', 'DATE_AND_TIME', 'GEOLOCATION', 'TELEGRAM_LOCATION'])) || (item.type === 'text'))
              ? '-webkit-fill-available' : 'fit-content',
            }}
          >
            {column.children && column.children.map((item, index) => {
              let itemTitle = item && item.title ? item.title : '';
              let itemPredicateId = item.id;
              const rstData = accordeonData
                ? getRstTrplsData(item, item, ancestorId, accordeonData.concept, accordeonData.rstId, accordeonData.accIndex)
                : getRstTrplsData(item, item, ancestorId );

              const fixedWidthItems = tobeor(item.type, ['BUTTON', 'OBJECT']) || item.compType === 'title';

              let conceptTrpls;
              if (item.type === 'text' && item.value && /\d/.test(item.value))
                conceptTrpls = data.trpls[ancestorId];

              return (
                <div
                  key={index} 
                  style={{
                    minHeight: '21px',
                    width: tobeor(item.type, ['BUTTON', 'OBJECT']) ? 'fit-content' :
                      item.compType === 'title' ? '50px' : '-webkit-fill-available',
                    marginBottom: (column.children.length > 1 && index < column.children.length - 1) ? '3px' : '',
                  }}
                  className={`${fixedWidthItems ? "" : classes.fillAvailable}`}
                  //${(column.children.length > 1 && index < column.children.length) ? classes.mb5 : ''}
                >
                  {item.type === 'text' ?
                    <div
                      style={{ fontSize: '11px', color: '#4c4c4c', margin: '2px' }}
                    >
                      {/<\/?[a-z][\s\S]*>/i.test(item.value) ?
                        <ParseHTML
                          htmlString={item.value}
                          variables={conceptTrpls}
                        />
                      :
                        <pre style={{ textWrap: 'auto' }}>{item.value}</pre>
                      }
                    </div>
                  : item.compType === 'title' ?
                    <div className={classes.mr5}>
                      <PidTitle
                        rst={item}
                        account={account}
                        rstData={rstData}
                        classes={classes}
                        itemTitle={itemTitle}
                        getRstMetaData={getRstMetaData}
                        itemPredicateId={itemPredicateId}
                      />
                    </div>
                  :
                    <TrplFormValRenderer
                      key={index}
                      rst={item}
                      data={data}
                      item={item}
                      formId={formId}
                      setTrpl={setTrpl}
                      classes={classes}
                      isGroup={isGroup}
                      groupId={groupId}
                      rstData={rstData}
                      isNewNode={isNewNode}
                      ancestorId={ancestorId}
                      loadingTids={loadingTids}
                      deletedTids={deletedTids}
                      getTrplNode={getTrplNode}
                      saveOnlyForm={saveOnlyForm}
                      isAnotherNode={isAnotherNode}
                      submitOnlyForm={submitOnlyForm}
                      onRstValueEdit={onRstValueEdit}
                      removeTrplValue={removeTrplValue}
                      setLoadingTids={setLoadingTids}
                      onRstTypeBtnClick={onRstTypeBtnClick}
                      onNodeRemoveClick={onNodeRemoveClick}
                      setDeletedTrplId={setDeletedTrplId}
                      openObjectEditModal={openObjectEditModal}
                      toggleUploadImgModal={toggleUploadImgModal}
                      isDisableTrplEditing={isDisableTrplEditing}
                      getAutocompleteTrpls={getAutocompleteTrpls}
                      resetDeletedTrplId={resetDeletedTrplId}
                      showEmptyValOnBounds={showEmptyValOnBounds}
                      onChangeTextereaHeight={onChangeTextereaHeight}
                      updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
                      openTrplRenderPartsModal={openTrplRenderPartsModal}
                      onWidgetCheckboxesValueEdit={onWidgetCheckboxesValueEdit}
                      onNodeAddDropdownElementClick={onNodeAddDropdownElementClick}
                    />
                  }
                </div>
              )
            })}
          </div>
        )
      })}
    </React.Fragment>
  )
};
